// flow

import Button from 'Components/Button';

const FormInput = ({
	label, disabled, name, value, setValue, placeholder, type,
	onKeyPress,
	errors,
	withButton,
	...otherProps
}) => (
	<div className="form-input-component">
		<div className="input-wrapper">
			{label && <span className="buttonCaps label">{label}</span>}

			<div className="input-content">
				<input
					value={value}
					onChange={(e) => setValue(e.target.value)}
					onKeyPress={onKeyPress}
					name={name}
					disabled={disabled}
					type={type || 'text'}
					placeholder={placeholder}
					className={`${errors[name] ? 'error' : ''} ${withButton ? 'group-btn' : ''}`}
					{...otherProps}
				/>
				{ withButton && (
					<Button {...withButton} />
				)}
			</div>

			{errors[name] && (
				<span className="error-message bodyBullet">
					{errors[name].message}
				</span>
			)}
		</div>
	</div>
);

FormInput.propTypes = {
	label: PropTypes.string,
	disabled: PropTypes.bool,
	name: PropTypes.string,
	type: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	setValue: PropTypes.func.isRequired,
	onKeyPress: PropTypes.func,
	placeholder: PropTypes.string,
	errors: PropTypes.instanceOf(Object),
	withButton: PropTypes.instanceOf(Object)
};

FormInput.defaultProps = {
	label: null,
	disabled: false,
	placeholder: null,
	name: '',
	type: 'text',
	value: '',
	errors: [],
	withButton: null,
	onKeyPress: null
};

export default FormInput;
